import useAxios from '../../utils/useAxios'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { rejectWithApiError } from '../../utils/reduxErrors'

export const getClaims = createAsyncThunk('claims/get', async (...args) => {
  try {
    const axios = useAxios()
    const { data } = await axios.get('/api/claims/')
    return data
  } catch (error) {
    const { rejectWithValue } = args[1]
    return rejectWithApiError(rejectWithValue, error)
  }
})

export const saveClaim = createAsyncThunk('claim/save', async (t, { rejectWithValue }) => {
  try {
    const axios = useAxios()
    const { data } = await axios.put(`/api/claims/${t.id}/`, t)
    return data
  } catch (error) {
    return rejectWithApiError(rejectWithValue, error)
  }
})

export const createClaim = createAsyncThunk('claim/create', async (t, { rejectWithValue }) => {
  try {
    const axios = useAxios()
    const { data } = await axios.post('/api/claims/', t)
    return data
  } catch (error) {
    return rejectWithApiError(rejectWithValue, error)
  }
})

export const deleteClaim = createAsyncThunk('claim/delete', async (t, { rejectWithValue }) => {
  try {
    const axios = useAxios()
    const { data } = await axios.delete(`/api/claims/${t.id}/`)
    return data
  } catch (error) {
    return rejectWithApiError(rejectWithValue, error)
  }
})
